import { cursorMap, pointerEventsMap, appearanceMap } from '../../../mappers.mappings.js';

var interactiveStyleMapper = {
  cursor: function cursor(value, _) {
    return {
      classNames: [cursorMap[value]]
    };
  },
  pointerEvents: function pointerEvents(value, _) {
    return {
      classNames: [pointerEventsMap[value]]
    };
  },
  appearance: function appearance(value, _) {
    return {
      classNames: [appearanceMap[value]]
    };
  },
  resize: function resize(value, _) {
    return {
      style: {
        resize: value
      }
    };
  }
};

export { interactiveStyleMapper };
//# sourceMappingURL=interactive.js.map
